import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgUnsatisfiedEmojiSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M24 40c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16Zm0-30.5C16 9.5 9.5 16 9.5 24S16 38.5 24 38.5 38.5 32 38.5 24 32 9.5 24 9.5Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M18.12 32.88a.71.71 0 0 1-.51-.21.755.755 0 0 1-.03-1.06c1.47-1.56 3.7-2.48 6.12-2.52 2.6-.06 5.03.86 6.71 2.5.3.29.3.76.01 1.06-.29.3-.76.3-1.06.01-1.39-1.36-3.45-2.11-5.63-2.08-2.02.04-3.87.79-5.06 2.05-.15.17-.35.25-.55.25Z",
    fill: "currentColor"
  }));
}

export { SvgUnsatisfiedEmojiSecondary as default };
